import { SvgIconModule } from '@core/modules/svgIcons.module';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslocoModule } from '@jsverse/transloco';
import { OverlayModule } from '@angular/cdk/overlay';
import { XtUiKitModule } from '@xt/ui-kit';
import { PageHeaderComponent } from './page-header.component';
import { ButtonModule } from '../../atoms/button/button.module';
import { PatientDetailsRepresentationPopupComponent } from '@xt/patient-list-cdk';
import { CypressDirectiveModule } from '../../../directives/cypress/cypress-directive.module';
import { TooltipDirectiveModule } from '../../../directives/tooltip/tooltip-directive.module';
import { XtPatientRepresentationsCdkModule } from '@xt/patient-representations-cdk';

@NgModule({
  declarations: [PageHeaderComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    TooltipDirectiveModule,
    RouterModule,
    ButtonModule,
    SvgIconModule,
    TranslocoModule,
    CypressDirectiveModule,
    OverlayModule,
    XtPatientRepresentationsCdkModule,
    XtUiKitModule,
    PatientDetailsRepresentationPopupComponent,
  ],
  exports: [PageHeaderComponent],
})
export class PageHeaderModule {}
